import { Component, Inject, OnInit, Renderer2 } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Observable, Subject, catchError, debounceTime, filter, of, switchMap, takeUntil } from "rxjs";
import { HeaderService } from "../header/header.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { ShipmentSku } from "src/app/models/shipyard.model";
import { Papa } from "ngx-papaparse";
import { ConfirmDialogComponent } from "../dialogs/confirm-dialog/confirm-dialog.component";
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { SettingsService } from "src/app/services/settings.service";
import { UpdateSkuQtyComponent } from "src/app/modules/shipyard/shipments-detail/update-sku-qty/update-sku-qty.component";

@Component({
  selector: "app-deduct-via-sku-dialog",
  templateUrl: "./deduct-via-sku-dialog.component.html",
  styleUrls: ["./deduct-via-sku-dialog.component.scss"],
})
export class DeductViaSkuDialogComponent implements OnInit {
  account: string;
  importBulk;
  spin: boolean = false;
  selectedSKU: any[] = [];
  skuItemDetail;
  validatorSpin = false;
  invalidSkus: string[] = [];
  warehouse: FormControl = new FormControl("", Validators.required);
  reason: FormControl = new FormControl("", Validators.required);
  validatedSku: boolean = false;
  private destroy$ = new Subject<void>();
  filteredOptions$: Observable<any>;
  importBulkForm: FormGroup = new FormGroup({
    skuList: new FormControl(null, [Validators.required]),
  });
  invalidFbatypeSkus: string[] = [];
  selectedWarehouse;
  skuForm: FormGroup = new FormGroup({
    skuAutocomplete: new FormControl(),
    skuQty: new FormControl(1,[Validators.required, Validators.pattern("^[0-9]*$")])
  });
  focus: boolean = false;
  warehouses: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private headerService: HeaderService,
    private snackBar: MatSnackBar,
    private shipyardService: ShipyardService,
    private papa: Papa,
    private dialog: MatDialog,
    private planyardService: PlanyardService,
    private settingsService: SettingsService,
    public dialogRef: MatDialogRef<DeductViaSkuDialogComponent>,
    private renderer: Renderer2
  ) {
    this.headerService.accountsSelected
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => (this.account = e[0]));
  }
  
  ngOnInit(): void {
    this.getWarehouse();
    this.filteredOptions$ = this.skuForm.get('skuAutocomplete').valueChanges.pipe(
      debounceTime(300),
      switchMap(value => 
        this.shipyardService.TypeaheadSku(this.account, value, '', null, true).pipe(
          catchError(error => {
            console.error('Error fetching options', error);
            return of([]);
          })
        )
      )
    );
  }

  getWarehouse() {
    this.settingsService
      .GetAllWarehouses()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any[]) => {
        this.warehouses = res;
      });
  }

  action(event) {
    if (event == "Proceed") {
      this.save();
    } else if (event == "Confirm") {
      this.inventoryUpdateBySku();
    } else if (this.importBulk) {
      this.importBulk = false;
      this.invalidSkus = [];
      this.validatedSku = false;
    }  else if (event == "Cancel") {
       if(this.importBulk) this.back();
       else {
        this.close();
       }
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  inventoryUpdateBySku() {
    this.spin = true;
    let items: any[] = [];
    let warehouseId;
    this.warehouses.filter((ele) => {
      if (ele.id == this.selectedWarehouse) {
        warehouseId = ele.warehouseId;
      }
    });
    this.skuItemDetail.forEach((sku, i) => {
      const delSku = {
        itemId: sku.itemId,
        qty: sku.qty,
        mappedQty: sku.mappedQty,
      };
      items.push(delSku);
    });
    const payload = {
      warehouseId: warehouseId,
      reason: this.reason.value,
      items: items,
    };

    this.planyardService
      .InventoryUpdateBySku(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 4000,
            horizontalPosition: "center",
            data: {
              title: "Inventory updated by sku successfully",
              action: "Dismiss",
              type: "success",
            },
          });
          this.dialogRef.close("Confirm");
        },
        error: (err) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 4000,
            horizontalPosition: "center",
            data: {
              title: err.error.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        },
      });
  }
  save() {
    this.spin = true;
    let skuQtyList: any[] = [];
    this.selectedSKU.forEach((sku, i) => {
      const delSku = {
        sku: sku.sku,
        qty: sku.qty,
        accountSkuId: sku.accountSkuId
      };
      skuQtyList.push(delSku);
    });
    const payload = {
      SkuQtyList: skuQtyList,
    };

    this.planyardService
      .skuItemDetail(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.spin = false;
          this.skuItemDetail = res;
          this.selectedSKU = [];
        },
        error: (err) => {
          this.spin = false;
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 4000,
            horizontalPosition: "center",
            data: {
              title: err.error.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        },
      });
  }

  validateSkus() {
    if (
      this.importBulkForm.value.skuList &&
      this.importBulkForm.value.skuList.length
    ) {
      const data = this.parseFromCsv(
        this.importBulkForm.value.skuList.trim()
      ).filter((res) => {
        return res.sku != "";
      });
      this.validate(data);
    }
  }

  parseFromCsv(file) {
    const parsedData = this.papa.parse(file, {
      delimiter: "\t",
      complete: (result: any) => {},
    });
    const returnArray = parsedData.data.map((element) => {
      return {
        sku: element[0],
        caseQty: this.data.isCaseQty ? parseInt(element[1], 10) : 0,
        qty:
          (this.data.isCaseQty
            ? parseInt(element[2], 10) * parseInt(element[1], 10)
            : parseInt(element[1], 10)) || 0,
      };
    });
    if (!returnArray[returnArray.length - 1].sku) returnArray.splice(-1, 1);
    return returnArray;
  }

  validate(result: any) {
    let api: any;
    this.validatorSpin = true;
    let data: any = {
      skuQtyList: result,
      account: this.account,
    };
    this.shipyardService
      .ValidateBulkSkus(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.importBulkForm.reset();
          this.validatedSku = true;
          this.validatorSpin = false;
          if (res && res.invalidSkus && res.invalidSkus.length) {
            this.invalidSkus = res.invalidSkus;
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 4000,
              horizontalPosition: "center",
              data: {
                title: `The following ${this.invalidSkus.length} ${"SKU  were not found"} : 
                ${this.invalidSkus.toString()}`,
                action: "Dismiss",
                type: "error",
              },
            });
          }
          if (res.validSkus && res.validSkus.length) {
            res.validSkus.forEach((item) => {
              item.CaseQty = item.caseQty || 0;
              this.selectedSKU.push(item as ShipmentSku);
            });
          }
        },
        error: (error) => {
          this.validatorSpin = false;
          this.importBulkForm.controls.skuList.setErrors({ incorrect: true });
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 5000,
            horizontalPosition: "center",
            data: {
              title: "Row(s) with invalid format. data must be Tab or Comma delimited",
              action: "Dismiss",
              type: "error",
            },
          });
        },
      });
  }

  removeSku(sku) {
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Remove SKU",
        message: `Are you sure you want to remove ${sku.sku || sku.title} from list ?`,
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        this.selectedSKU = this.selectedSKU.filter(
          (currentSku) => sku.sku !== currentSku.sku
        );
      });
  }
  removeSkuItemDetail(sku) {
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Remove SKU",
        message: `Are you sure you want to remove ${sku.sku || sku.title} from list ?`,
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        this.skuItemDetail = this.skuItemDetail.filter(
          (currentSku) => sku.name !== currentSku.name
        );
      });
  }

  onWarehouseChange(e) {
    this.selectedWarehouse = e.target.value;
  }

  onChange(event){
    if(event.option.value){
      this.focus = false;
       this.renderer.selectRootElement('#qty').focus();
    }
  }

  
  verifyAndLoadSku() {
    const data = {
      skuQtyList: [
        {
          sku: this.skuForm.value.skuAutocomplete.sku ?  this.skuForm.value.skuAutocomplete.sku : this.skuForm.value.skuAutocomplete,
          qty: this.skuForm.value.skuQty,
        },
      ],
      account: this.account,
    };
    this.shipyardService.ValidateBulkSkus(data).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res && res.validSkus && res.validSkus.length > 0) {     
        this.loadSku(res.validSkus[0]);
        this.focus = false;
        this.renderer.selectRootElement('#skuAutocomplete').focus();         
      } else {
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: 'Invalid SKU, please try again.',
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
      }
    });
  }

  loadSku(res) {
    let foundSku = [];
    if (typeof this.skuForm.value.skuAutocomplete === 'string') {
      this.shipyardService
          .TypeaheadSku(this.account, this.skuForm.value.skuAutocomplete).pipe(takeUntil(this.destroy$))
          .subscribe((skus: ShipmentSku[]) => {
            foundSku = skus.filter((val) => val.sku === this.skuForm.value.skuAutocomplete);
            this.setSKuData(foundSku,res);
          });
    } else {
      this.setSKuData(foundSku,res);
    }
  }

  setSKuData(foundSku,res) {
    if (
        foundSku.length === 1 ||
        (this.skuForm.value.skuAutocomplete &&
            this.skuForm.value.skuAutocomplete.sku)
    ) {
      const sku =
          foundSku && foundSku.length
              ? foundSku[0]
              : this.skuForm.value.skuAutocomplete;
      sku.qty = this.skuForm.value.skuQty;
      sku.prep= res.prep;
      sku.fnSku = res.fnsku;
      sku.fbaType= this.skuForm.value.skuAutocomplete.fbaType ? this.skuForm.value.skuAutocomplete.fbaType : res.fbaType;
      sku.accountType= res.accountType;
      sku.length = res.length;
      sku.width = res.width;
      sku.height = res.hight;
      if (this.selectedSKU.some((b) => b.sku === sku.sku)) {
        const matchSku = this.selectedSKU.filter((b) => b.sku === sku.sku);
        matchSku[0].qty = +matchSku[0].qty + +sku.qty;
      } else {
        this.selectedSKU.push(sku as ShipmentSku);
      }
      this.skuForm.reset();
      this.skuForm.get("skuQty").setValue(1);
    } else {
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: 'Invalid SKU, please try again',
              action: 'Dismiss',
              type: 'error',
            },
          }
      );
    }
  }

  displayWith(value: ShipmentSku) {
    if (value) {
      return value.sku;
    }
  }

  onPaste($event: ClipboardEvent) {
    const pastedText = $event.clipboardData.getData('text');
    this.skuForm.get('skuAutocomplete').setValue(pastedText);
  }


  change(event,name?){
    if(event.keyCode == 9 && name == "qty" ){
       this.focus = true;
    } else{
      this.focus = false;
    }
  }

  updateQty(sku) {
    this.dialog
      .open(UpdateSkuQtyComponent, {
        data: {
          title: "Update Quantity",
          inputLabel: "New Quantity",
        },
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => {});
  }

  back() {
    this.importBulk = false;
  }
}
